import { ReactNode } from 'react';
import clsx from 'clsx';
import styles from './callout.module.scss';
import { CalloutTone } from './callout.types';

interface CalloutProps {
  tone?: CalloutTone;
  title?: string;
  children: ReactNode;
  className?: string;
}

export default function Callout({ tone = 'soft', title, children, className }: CalloutProps) {
  return (
    <div className={clsx(styles.callout, styles[`callout-${tone}`], className)}>
      {title && <b className={styles.title}>{title}</b>}
      {children}
    </div>
  );
}
